export const humanizeFilesize = fileSize => {
  let i = -1;
  const UNITS = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];

  do {
    fileSize /= 1024;
    i++;
  } while (fileSize > 1024);

  return Math.max(fileSize, 0.1).toFixed(1) + UNITS[i];
};



// WEBPACK FOOTER //
// ./src/models/File.js